export default __webpack_public_path__ + "static/media/pacmanb.c127d024.svg";